import React, { Component } from 'react';
import Featuredblock from '../components/Featuredblock'; 
import Articlelist from '../components/Articlelist'; 
import KalenderList from '../components/KalenderList'; 
import NewsBox from '../components/NewsBox'; 
import Flexbox from '../components/misc/Flexbox'; 
import KalenderAnmelden from '../components/KalenderAnmelden'; 

class Home extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  anmelden:'',
		  kalenderName:''
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}
	handleOpen(data){
		this.setState({
			anmelden:'open',
			kalenderName:data[0],
			kalenderDate:data[1],
			perform:data[2],
			type:data[3],
			kalenderTime:data[4]
		});
		document.body.classList.toggle('no-scroll');
	}
	handleClose(){
		this.setState({
			anmelden:''
		});
		document.body.classList.toggle('no-scroll');
	}
	render(){ 
		const {homeData,kalenderData,page,staticData} = this.props;
		let cols = (homeData[0].aktuelles_home_name!=='') ? 'col-md-8 event-calendar-wrapper' : 'col-md-12 event-calendar-wrapper'; 
		let kalender_left = homeData[0].kalender_left;
		let	kalender_right = homeData[0].kalender_right;	
		return (
		
			<div className="home">		
				<div className="lg-side-padding container-fluid">
					<Featuredblock clock = {staticData.label_clock} height={true} {...homeData[0]}/>
				</div>
				<div className="container-fluid lg-side-padding  article-list-section">
					<div className="row">					
						<div className="col-md-6">
							{
								homeData.map( (data,i) =>
									<Articlelist 
										key={i} 
										left = {data.vorschau_home_left}
										right = {data.vorschau_home_right}
										type = {data.vorschau_home_type}
										name = {data.vorschau_home_name}
										slug = {data.vorschau_home_slug}
										image = {data.vorschau_home_image}
										video = {data.vorschau_home_id}
										start = {data.vorschau_home_start_date}
										end = {data.vorschau_home_end_date}	
										time = {data.vorschau_home_time}	
										showDate = {data.vorschau_home_show_date}
										showText = {data.vorschau_home_show_text}
										clock = {staticData.label_clock}
									/>
								)
							}
						</div>					
						<div className="col-md-6  article-list-two">
							{
								homeData.map( (data,i) =>
									<Articlelist 
										key={i} 
										left = {data.ruckblick_home_left}
										right = {data.ruckblick_home_right}
										type = {data.ruckblick_home_type}
										name = {data.ruckblick_home_name}
										slug = {data.ruckblick_home_slug}
										image = {data.ruckblick_home_image}
										video = {data.ruckblick_home_id}
										start = {data.ruckblick_home_start_date}
										end = {data.ruckblick_home_end_date}	
										time = {data.ruckblick_home_time}	
										showDate = {data.ruckblick_home_show_date}
										showText = {data.ruckblick_home_show_text}	
										clock = {staticData.label_clock}
									/>
								)
							}
						</div>					
					</div>
				</div>
				<div className="container-fluid lg-side-padding events-calendar-section">
					<div className="row">
						{
						(kalenderData.length)?
						<div className={cols}>
							<Flexbox left={kalender_left} right={kalender_right} />
							<KalenderList staticData={staticData} handleClick={this.handleOpen} data={kalenderData} />
						</div>	
						:null
						} 
						{
							(homeData[0].aktuelles_home_name) ?
								<div className="col-md-4">
									{
										homeData.map( (data,i) =>
											<NewsBox 
												key={i} 
												left = {data.aktuelles_left}
												right = {data.aktuelles_right}
												name = {data.aktuelles_home_name}
												slug = {data.aktuelles_home_slug}
												image = {data.aktuelles_home_image}
												date = {data.aktuelles_home_date}
												text = {data.aktuelles_home_text}		
												staticData={staticData}	
											/>
										)
									}
								</div>
							: <div></div> 
						}
						<KalenderAnmelden staticData={staticData} {...page} eventdate={this.state.kalenderDate} kalender={this.state.kalenderName} handleClick={this.handleClose} kalenderTime={this.state.kalenderTime} perform={this.state.perform} formType={this.state.type} status={this.state.anmelden} />
					</div>
				</div>
			</div>		
		)
	}
}
export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js